import { motion, AnimatePresence } from "framer-motion";
import {
  Calendar,
  Clock,
  FileText,
  Building2,
  User,
  Wrench,
  MessageSquare,
  CheckSquare,
  Tag,
} from "lucide-react";

export default function Detalhe({ chamado, onClose }) {
  return (
    <AnimatePresence>
      {chamado && (
        <motion.div
          className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0, y: 50 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.9, opacity: 0, y: 50 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="bg-white rounded-lg shadow-xl w-[950px] max-h-[90vh] overflow-y-auto relative"
          >
            {/* Barra superior */}
            <div className="flex items-center justify-between px-4 py-3 bg-[#2b2b2b] rounded-t-lg">
              <h2 className="text-lg font-semibold text-white flex items-center gap-2">
                📋 Detalhes do Chamado
              </h2>
              <button
                onClick={onClose}
                className="w-8 h-8 flex items-center justify-center bg-white rounded-full shadow hover:scale-110 transition-transform duration-200"
              >
                ✕
              </button>
            </div>

            {/* Conteúdo */}
            <div className="p-6 space-y-4 text-gray-700">
              {/* Linha 1 */}
              <div className="grid grid-cols-3 gap-4">
                <div>
                  <label className="flex items-center gap-2 text-sm font-bold text-gray-800">
                    <Calendar size={16} /> Data
                  </label>
                  <input
                    value={chamado.data_abertura}
                    readOnly
                    className="w-full border rounded-md px-2 py-1 bg-gray-100"
                  />
                </div>
                <div>
                  <label className="flex items-center gap-2 text-sm font-bold text-gray-800">
                    <Clock size={16} /> Hora
                  </label>
                  <input
                    value={chamado.hora_abertura}
                    readOnly
                    className="w-full border rounded-md px-2 py-1 bg-gray-100"
                  />
                </div>
                <div>
                  <label className="flex items-center gap-2 text-sm font-bold text-gray-800">
                    <FileText size={16} /> Tipo de Serviço
                  </label>
                  <input
                    value={chamado.tipo_servico}
                    readOnly
                    className="w-full border rounded-md px-2 py-1 bg-gray-100"
                  />
                </div>
              </div>

              {/* Linha 2 */}
              <div className="grid grid-cols-3 gap-4">
                <div>
                  <label className="flex items-center gap-2 text-sm font-bold text-gray-800">
                    <Building2 size={16} /> Empresa
                  </label>
                  <input
                    value={chamado.empresa}
                    readOnly
                    className="w-full border rounded-md px-2 py-1 bg-gray-100"
                  />
                </div>
                <div>
                  <label className="flex items-center gap-2 text-sm font-bold text-gray-800">
                    <User size={16} /> Colaborador
                  </label>
                  <input
                    value={chamado.colaborador}
                    readOnly
                    className="w-full border rounded-md px-2 py-1 bg-gray-100"
                  />
                </div>
                <div>
                  <label className="flex items-center gap-2 text-sm font-bold text-gray-800">
                    <Wrench size={16} /> Técnico
                  </label>
                  <input
                    value={chamado.tecnico_responsavel}
                    readOnly
                    className="w-full border rounded-md px-2 py-1 bg-gray-100"
                  />
                </div>
              </div>

              {/* Relato */}
              <div>
                <label className="flex items-center gap-2 text-sm font-bold text-gray-800">
                  <MessageSquare size={16} /> Relato do Problema
                </label>
                <textarea
                  value={chamado.relato_problema || "Sem relato informado."}
                  readOnly
                  className="w-full border rounded-md px-2 py-2 bg-gray-100 min-h-[80px]"
                />
              </div>

              {/* Solução */}
              <div>
                <label className="flex items-center gap-2 text-sm font-bold text-gray-800">
                  <CheckSquare size={16} /> Solução do Problema
                </label>
                <textarea
                  value={chamado.solucao_problema || "Sem solução registrada."}
                  readOnly
                  className="w-full border rounded-md px-2 py-2 bg-gray-100 min-h-[80px]"
                />
              </div>

              {/* Estado e Finalizado */}
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="flex items-center gap-2 text-sm font-bold text-gray-800">
                    <Tag size={16} /> Estado
                  </label>
                  <div
                    className={`px-3 py-2 rounded-md font-semibold w-full ${
                      chamado.status === "Finalizado"
                        ? "bg-green-100 text-green-800"
                        : chamado.status === "Pendente"
                        ? "bg-yellow-100 text-yellow-800"
                        : "bg-gray-200 text-gray-700"
                    }`}
                  >
                    {chamado.status}
                  </div>
                </div>
                <div>
                  <label className="flex items-center gap-2 text-sm font-bold text-gray-800">
                    <Calendar size={16} /> Finalizado em
                  </label>
                  <input
                    value={chamado.finalizado_em || "0000-00-00"}
                    readOnly
                    className="w-full border rounded-md px-2 py-1 bg-gray-100"
                  />
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
